// extracted by mini-css-extract-plugin
export default {"root":"About_root__GW78W","logo":"About_logo__KIFjA","p":"About_p__f02Bz","small":"About_small__MCOHy","placeHolderShimmer":"About_placeHolderShimmer__pi4Xl"};